import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import loaderGif from "../../../../../assets/images/loader.gif";
import { Tooltip } from 'react-tooltip';
import './../users.css';
import button from "../../../../button.module.css";

const UsersList = ({ tableData, onDeleteUser, addsubUser, getUser, changePw, onSort, updateStatus, delUser, search, loader , selectedUserRole}) => {
    const navigate = useNavigate();
    const [expandedRows, setExpandedRows] = useState([]); // State to track expanded rows
    const [selectedUser, setSelectedUser] = useState(null);

    const userListData = (id) => {
        getUser(id);
    };

    const passChangePwId = (id) => {
        changePw(id);
    };

    const handleSort = (column) => {
        onSort(column);
    };

    const handleClientReport = (id, name) => {
        localStorage.setItem("clientName", name);
        navigate(`/supply-overview/${id}`);
    };

    const handleDemandReport = (id, name) => {
        localStorage.setItem("demandName", name);
        navigate(`/demand-overview/${id}`);
    };
    
    useEffect(() => {
        setExpandedRows([]);
      }, [selectedUserRole, search]);
      

    const toggleRow = (index) => {
        if (expandedRows.includes(index)) {
            setExpandedRows(expandedRows.filter((row) => row !== index));
        } else {
            setExpandedRows([...expandedRows, index]);
        }
    };

    const addSubUser = (id) => {
        addsubUser(id)
    }


    return (
        <>
            <div className="table-responsive custom-table">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th className='partner' onClick={() => handleSort('name')}>Name <i className="fas fa-sort"></i></th>
                            <th className='email' onClick={() => handleSort('email')}>Email <i className="fas fa-sort"></i></th>
                            <th className='partner' onClick={() => handleSort('company')}>Company <i className="fas fa-sort"></i></th>
                            <th className='partner' onClick={() => handleSort('role')}>Role <i className="fas fa-sort"></i> </th>
                            
                            <th className="deal-name" onClick={() => handleSort('previllage')}>Report Metrics <i className="fas fa-sort"></i></th>
                            <th className="margin" onClick={() => handleSort('margin')} >Margin % <i className="fas fa-sort"></i></th>
                            <th className="status">Status </th>
                            <th className="action" >Action </th>
                        </tr>
                    </thead>

                    {!loader ? (
                        <tbody>
                            {tableData && tableData.length > 0 ? (
                                tableData?.map((item, i) => (
                                    <React.Fragment key={i}>
                                        {/* Main Row */}
                                        <tr>
                                            <td>{i + 1}</td>
                                            <td className="wrap-string text-capitalize"><i className={`fa ${expandedRows.includes(i) ? 'fa-minus-circle' : 'fa-plus-circle'}`}  onClick={() => toggleRow(i)}></i> {item?.name}</td>
                                            <td>{item?.email}</td>
                                            <td className="action">{item?.company}</td>
                                            <td className="action">{item.user_type}</td>
                                            
                                            <td className="deal-name">{item?.privilege}</td>
                                            <td className="margin text-end">{item?.margin}</td>
                                            <td className="text-center status">
                                                <label className="custom-switch">
                                                    <input 
                                                        type="checkbox" 
                                                        checked={item?.status === 1} 
                                                        onClick={() => updateStatus(item.id, item.status === 1 ? 0 : 1)} 
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </td>
                                            <td className="action">
                                                <div className="table-icons">
                                                    <i class="fa-solid fa-user-plus dark-blue" onClick={() => addSubUser(item?.id)}></i>
                                                    <i className="fa-regular fa-pen-to-square green" onClick={() => userListData(item?.id)}></i>
                                                    <i className="fa-solid fa-trash-can red" onClick={() => delUser({id:item.id})}></i>
                                                    {/* <i className="fa-solid fa-key grey" onClick={() => passChangePwId(item.id)}></i> */}
                                                    {item.user_type === 'Client' && (
                                                        <i className="fa-regular fa-eye blue" onClick={() => handleClientReport(item.id, item.name)}></i>
                                                    )}
                                                    {item.user_type === 'Demand' && (
                                                        <i className="fa-regular fa-eye blue" onClick={() => handleDemandReport(item.id, item.name)}></i>
                                                    )}
                                                    <i data-bs-toggle="modal" data-bs-target="#loginModal" class="fas fa-info-circle" onClick={() => setSelectedUser(item)}></i>
                                                </div>
                                            </td>
                                        </tr>

                                        {/* Expanded Row */}
                                        {expandedRows.includes(i) && (
                                            <tr>
                                                <td colSpan="9" >
                                                    <div className="expanded-row">
                                                        <div className='head d-flex justify-content-between'>
                                                            <p>Email</p>
                                                            <p>Currency</p>  
                                                            <p>Action</p>                                                       
                                                        </div>
                                                       <div className='contentWraper'>
                                                        {item?.addition_info.map((info) => (
                                                            <div className='content d-flex justify-content-between'>
                                                                <p>{info.email}</p>
                                                                <p>{info.currency}</p>
                                                                <p className="table-icons" >
                                                                    <i className="fa-solid fa-trash-can red" onClick={() => delUser({sub_id: info.id, user_id: info.user_id})}></i>
                                                                    <i className="fa-solid fa-key grey" onClick={() => passChangePwId(info.id)}></i>
                                                                </p>  
                                                            </div>
                                                            ))}
                                                       </div>
                                                        
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center">No Data Found</td>
                                </tr>
                            )}
                        </tbody>
                    ) : (
                        <div className={`loader ${loader ? 'show' : ''}`}>
                            <label>
                                <img src={loaderGif} alt="Loading..." />
                            </label>
                        </div>
                    )}
                </table>
            </div>

            <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />

            {/* 🆕 Login Modal */}
            <div className="modal" id="loginModal">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            {/* <h4 className="modal-title">User Login Info</h4> */}
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        <div className="modal-body">
                            <div className="form-wraper userLoginLogModal">          
                                <p><span className='userLoginLog'>Last Login:</span> <span className='userLoginLogText'>{selectedUser?.logged_in_time || 'N/A'}</span></p>
                                <p><span className='userLoginLog'>Previous Login:</span> <span className='userLoginLogText'>{selectedUser?.last_logged_in_time || 'N/A'}</span></p>
                                {/* <p><strong>Activity Page:</strong> {selectedUser?.activity_page || 'N/A'}</p> */}
                                {/* <div className="form-group"><label>Last Login:{selectedUser?.logged_in_time || 'N/A'}</label></div>
                                <div className="form-group"><label>Previous Login:{selectedUser?.last_logged_in_time || 'N/A'}</label></div> */}
                            </div>
                        </div>

                        <div className="modal-footer">
                            {/* <button type="button" className={`${button.btn} ${button.btnBlue}`} data-bs-dismiss="modal">Close</button> */}
                        </div>

                    </div>
                </div>
            </div>


        </>
    );
};

export default UsersList;
